import { cn } from "@/lib/utils";

export type ImageProps = {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  loading?: "lazy" | "eager";
  decoding?: "async" | "sync" | "auto";
  className?: string;
  style?: React.CSSProperties;
};

export const Image = ({
  src,
  alt,
  width,
  height,
  loading = "lazy",
  decoding = "async",
  className,
  style,
}: ImageProps): React.ReactElement => {
  return (
    <img
      alt={alt}
      className={cn("h-full w-full object-cover", className)}
      decoding={decoding}
      height={height}
      loading={loading}
      src={src}
      style={style}
      width={width}
    />
  );
};
